<template>
	<div>
		<el-drawer
				title="消息列表"
				:visible.sync="msgDrawerVisible"
				size="50%"
				direction="rtl"
		>
			<div class="noticeWrapper">
				<div class="noticeItem" v-for="(item, index) in noticeList" :key="index" :style="{
          '--read': item.messageStatus == '2' ? '#297FFD' : '#F15151'
        }"
				@click="showDetail(item)"
				>
					<div class="noticeName">
						<span>{{ item.name || '通知' }}</span>
					</div>
					<div class="noticeContent">
						<div class="contentText">{{ item.text }}</div>
						<div class="time">
							<span>{{ item.createTime }}</span>
						</div>
					</div>
				</div>
			</div>
			<el-pagination
					background
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pageSize"
					layout="total, prev, pager, next, jumper"
					:total="total"
			/>
		</el-drawer>
		<MessageDetail ref="MessageDetail" @read="read"/>
	</div>

</template>
<script>
import MessageDetail from './MessageDetail.vue';
import {getMessageByUserId} from '@/api/viewIndex';
import moment from 'moment/moment';

export default {
	name: 'MessageDrawer',
	components: {MessageDetail},
	data() {
		return {
			msgDrawerVisible: false,
			noticeList: [],
			currentPage: 1,
			pageSize: 5,
			total: 0,
			userInfo: JSON.parse(sessionStorage.getItem('userInfo_portalUI')) || {}
		};
	},
	methods: {
		init() {
			this.msgDrawerVisible = true;
			this.getList()
		},
		read() {
			this.$emit('read');
			this.getList()
		},
		getList() {
			getMessageByUserId({
				pageNum: this.currentPage,
				// pageNum: 2,
				pageSize: this.pageSize,
				userId: this.userInfo.userId,
			}).then(res => {
				const { records = [] } = res.data.result
				this.noticeList = records.map(item => {
					return {
						...item,
						createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
					};
				});
				this.total = res.data.result.total;
			}).catch(err => {
				console.log(err);
			})
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getList()
		},
		showDetail(item) {
			this.$refs.MessageDetail.init(item);
		},
		close() {
			this.msgDrawerVisible = false;
			this.currentPage = 1;
		},
	},
};
</script>
<style scoped lang="scss">
.noticeWrapper {
	height: min-content;
	max-height: 88%;
	padding: 15px 20px;
	color: #333333;
	overflow-y: auto;

	.title {
		display: flex;
		justify-content: space-between;
		margin-bottom: 25px;

		.more {
			color: #999999;
			font-size: 14px;
			cursor: pointer;
		}
	}
}

.noticeItem {
	font-size: 16px;
	height: 110px;
	margin-top: 5px;
	cursor: pointer;

	.noticeName {
		font-weight: 600;
		//margin-bottom: 10px;

		.readTip {
			color: #ffffff;
			margin-right: 6px;
			display: inline-block;
			padding: 3px 6px;
			background-color: #F15151;
			font-size: 12px;
			border-radius: 4px;
			font-weight: normal;
		}

		&::before {
			content: '';
			display: inline-block;
			width: 8px;
			height: 8px;
			background: var(--read);
			border-radius: 50%;
			margin-right: 6px;
		}
	}

	.noticeContent {
		padding: 10px;
		//background-color: #F7F7F7;
		//margin-bottom: 10px;
		border-radius: 4px;
		color: #666666;
		border-bottom: 1px solid #d6d3d3;

		.contentText {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			margin-bottom: 10px;
		}

		.time {
			font-size: 14px;
			text-align: right;
		}
	}
}

::v-deep.el-pagination {
	text-align: center;
}
</style>
